<!-- @format -->
@if (krakenContent) {
	<div
		id="krakenContent"
		homeUtilsAppRunScripts
		[attr.data-sectionnum]="addlData.tagSectionNum"
		[innerHTML]="krakenContent | bypassSanitization"></div>
}
